<template>
<loading :show="show" :label="label" :overlay="overlay"></loading>
    <form class="form-horizontal">
        <div class="form-body">
            <div class="form-group">
                <div class="col-md-4 input-entidade">
                    <label class="control-label">Entidade</label>
                    <select class="form-control">
                    </select>
                </div>

                <div class="col-md-2 new-padding-inputs input-modalidade">
                    <label class="control-label">Modalidade</label>
                    <select class="form-control">
                        <option value="">Todas</option>
                        <option value="LAN">Lançamento</option>
                        <option value="REC">Recebimento</option>
                    </select>
                </div>

                <div class="col-md-2 new-padding-inputs input-tipo">
                    <label class="control-label">Tipo</label>
                    <select class="form-control">
                        <option value="">Todas</option>
                        <option value="1">Orçamentaria</option>
                        <option value="2">Extra Orçamentaria</option>
                    </select>
                </div>

                <div class="col-md-2 new-padding-inputs input-data input-datainicial">
                    <label class="control-label" >Data Inicial</label>
                    <input type="text" class="form-control datepicker">
                </div>
                <div class="col-md-2 new-padding-inputs input-data input-datafinal">
                    <label class="control-label">Data Final</label>
                    <input type="text" class="form-control datepicker">
                </div>                                

                <div class="col-md-5 new-padding-inputs input-credor input-natureza">
                    <label class="control-label">Natureza</label>
                    <input type="text" class="form-control" placeholder="natureza">
                </div>

                <div class="col-md-2 botao-pesquisar">
                    <label class="control-label"></label>
                    <button class="form-control btn green" style="margin-top: 8px;" v-on:click="pesquisar">Pesquisar</button>
                </div>
            </div>
        </div>
    </form>    
    <hr >
    <div>
        <div class="portlet-body">
            <cp-table-quatro v-if="line == 'table6'" :dadosconteudo="dadosconteudo"></cp-table-quatro>
        </div>
    </div>
</template>
<script>
    import CpTableQuatro from '../../tables/table-t6/table.vue'
    import loading from 'vue-full-loading'

            export default{
                data() {
                    return{
                        dadosconteudo: {},
                        show: false,
                        label: 'Carregando...',
                        overlay: true
                    }
                },
                components: {
                    CpTableQuatro, loading
                },
                props: {
                    line: {}
                },
                watch: {
                    $route () {
                        this.pesquisar();
                    }
                }, 
                methods: {
                    pesquisar(ev) {
                        $.ajaxSetup({
                            async: false
                        });

                        this.show = true;
                        var self = this;
                        //json com os dados do menu
                        setTimeout(function(){
                            MPL.loadDadosReceita(1, function (links)
                            {
                                self.dadosconteudo = links[0];
                                self.show = false;
                                $('.table-responsive').fadeIn('fast');
                                //console.log(self.dadosconteudo)
                            });
                        }, 200);

                        $.ajaxSetup({
                            async: true
                        });

                        // $('.table-responsive').fadeIn('fast');
                    }
                },
                ready() {
                    $.ajaxSetup({
                        async: false
                    })
                    $.getScript("./src/assets/assets-metronic/plugins/bootstrap-datepicker/js/bootstrap-datepicker.js");

                    $.ajaxSetup({
                        async: true
                    });

                    MPL.loadSelectsReceita();

                    MPL.handleFiltroReceita();

                    $('.datepicker').datepicker({
                        autoclose: true,
                        todayHighlight: true,
                        format: 'dd/mm/yyyy'
                    });
                    $('form').bind('submit',function(e){e.preventDefault();});
                    this.pesquisar();
                }
            }
</script>

<style scoped>
    @media (min-width: 992px){
        .input-entidade{
            width: 45.5%;
            padding-right: 5px;
        }

        .input-credor{
            width: 45.666667%;
            padding-left: 15px;
        }

        .data-inicial{
            padding-left: 15px;
        }

        .botao-pesquisar{
            float: right;
            padding-right: 15px;
        }
    }
</style>


// WEBPACK FOOTER //
// filtro5.vue?725a2652